type TFormData = [string, any];
export const getFormData = (data: TFormData[]) => {
  const fromData = new FormData();
  data.forEach((item) => {
    fromData.append(item[0], item[1]);
  });
  return fromData;
};
